import {
  FilterSelect,
  type FilterSelectOption,
  type FilterSelectProps,
} from "./filter-select";

export type DateFilterSelectOption = FilterSelectOption;
export type DateFilterSelectProps = FilterSelectProps;

export function DateFilterSelect(props: DateFilterSelectProps) {
  return <FilterSelect {...props} />;
}
